/**
 * Aligne une boite sur la planche ou sur les autres boites.
 * Chaque axe choisit sa ligne candidate la plus proche.
 * La rotation des boites n'est pas prise en compte.
 */
/** Rectangle sans rotation. */
export interface TBox { x: number; y: number; width: number; height: number }
/** Guide visible lors d'un alignement. */
export interface TGuide { orientation: 'vertical' | 'horizontal'; position: number }
/** Position alignee et guides correspondants. */
export interface TSnapResult { x: number; y: number; guides: TGuide[] }

const closestLine = (edges: number[], candidates: number[], threshold: number):
  { shift: number; position: number } | null => {
  let best: { shift: number; position: number } | null = null;
  for (const position of candidates) {
    for (const edge of edges) {
      const shift = position - edge;
      if (Math.abs(shift) <= threshold && (!best || Math.abs(shift) < Math.abs(best.shift))) {
        best = { shift, position };
      }
    }
  }
  return best;
};

/** Aligne une boite sur les lignes proches, puis sur la grille si besoin. */
export const snapBox = (moving: TBox, others: TBox[],
  artboard: { width: number; height: number },
  options?: { threshold?: number; grid?: number }): TSnapResult => {
  const threshold = options?.threshold ?? 6;
  const vertical = [0, artboard.width / 2, artboard.width];
  const horizontal = [0, artboard.height / 2, artboard.height];
  for (const box of others) {
    vertical.push(box.x, box.x + box.width / 2, box.x + box.width);
    horizontal.push(box.y, box.y + box.height / 2, box.y + box.height);
  }
  const xLine = closestLine([moving.x, moving.x + moving.width / 2, moving.x + moving.width],
    vertical, threshold);
  const yLine = closestLine([moving.y, moving.y + moving.height / 2, moving.y + moving.height],
    horizontal, threshold);
  const grid = options?.grid && options.grid > 0 ? options.grid : null;
  const x = xLine ? moving.x + xLine.shift : grid ? Math.round(moving.x / grid) * grid : moving.x;
  const y = yLine ? moving.y + yLine.shift : grid ? Math.round(moving.y / grid) * grid : moving.y;
  const guides: TGuide[] = [];
  if (xLine) guides.push({ orientation: 'vertical', position: xLine.position });
  if (yLine) guides.push({ orientation: 'horizontal', position: yLine.position });
  return { x, y, guides };
};
